module.exports = __webpack_public_path__ + "static/media/card-frilat.e626e37b.png";